import { useRef } from 'react';

/**
 * Lenis smooth scroll — TEMPORARILY DISABLED.
 *
 * The hook is kept as a no-op so existing call sites compile without changes,
 * but no Lenis instance is created and `window.__lenis` is never set, which
 * causes ScrollToTop / scroll-lock helpers to gracefully fall back to native
 * browser scrolling. Re-enable by restoring the previous implementation.
 */
export function useLenis() {
  const lenisRef = useRef<null>(null);
  return lenisRef;
}
